import { render } from "./myFooter.vue?vue&type=template&id=0ecd829b&scoped=true"
import script from "./myFooter.vue?vue&type=script&lang=js"
export * from "./myFooter.vue?vue&type=script&lang=js"

import "./myFooter.vue?vue&type=style&index=0&id=0ecd829b&scoped=true&lang=scss"

import exportComponent from "/builds/simply-frontend/simply-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecd829b"]])

export default __exports__